import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const HeaderSection = styled.div`
  margin-bottom: ${space.xl6};

  .icon {
    font-size: 7rem;
    margin: 0 ${space.sm};
  }

  .icon2 {
    margin-right: ${space.xl5};
  }

  @media (min-width: ${breakpoint.lg2}) {
    display: flex;
  }
`

export const Sections = styled.div`
  width: 100%;
`

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${space.sm};
  margin-top: ${space.lg};

  @media (min-width: ${breakpoint.lg2}) {
    margin-top: 0;
  }
`

export const Box = styled.div`
  margin: ${space.md};
  width: 100%;

  @media (min-width: ${breakpoint.lg}) {
    margin: 0;
    padding-left: ${space.xs2};
    display: flex;
    gap: ${space.xs};
    position: relative;
  }
`

export const GreenBox = styled.div`
  display: flex;
  flex-direction: column;
  background: linear-gradient(to right, #35aa5c 0%, #268156 100%);
  max-width: 18rem;
  height: 235px;
  padding: ${space.lg};
  border-radius: 0.85rem;
  margin: ${space.md};

  :nth-child(1) {
    background: #9df998;
  }

  :nth-child(2) {
    & p {
      color: #fff;
    }
  }

  @media (min-width: ${breakpoint.hd}) {
    margin: 0;
  }
`

export const Milestones = styled.div`
  position: relative;
  top: ${space.xs};
  border-radius: 0.85rem;
  width: 100%;
  padding: ${space.sm} ${space.md} ${space.xs2};

  background: linear-gradient(to right, #2a8c58 0%, #07263d 100%);

  & li {
    margin-bottom: ${space.xs2};
    color: #fff;
  }
  & ul {
    margin-bottom: 0;
  }
`
